import React, { useState, useEffect } from "react";
import "./graphicsRadius.css";

const GraphicsRadius = (props) => {
  const { legend, signal, data: initialData, backGraphic: initialBackGraphic, size } = props;

  const [data, setData] = useState(Math.max(0, initialData));
  const [backGraphicData, setBackGraphicData] = useState(Math.max(0, initialBackGraphic));
  const [color, setColor] = useState("rgb(192, 192, 192)");
  const [backGraphicColor, setBackGraphicColor] = useState("rgb(192, 192, 192)");
  const [rotate, setRotate] = useState(0);
  const [backGraphicRotate, setBackGraphicRotate] = useState(0);
  const [className, setClassName] = useState("");

  useEffect(() => {
    // Atualiza valores de data e backGraphicData
    setData(Math.max(0, initialData));
    setBackGraphicData(Math.max(0, initialBackGraphic));
  }, [initialData, initialBackGraphic]);

  useEffect(() => {
    // Define as cores com base no valor de data
    if (data > 0 && data < 50) {
      setColor("rgb(255, 0, 0)");
      setBackGraphicColor("rgb(255,192,192)");
    } else if (data >= 60 && data <= 100 || data > 100) {
      setColor("rgb(2, 143, 13)");
      setBackGraphicColor("rgb(164, 252, 171)");
    } else if (data >= 50 && data <= 60) {
      setColor("rgb(255, 230, 0)");
      setBackGraphicColor("rgb(252, 243, 154)");
    } else {
      setColor("rgb(192, 192, 192)");
      setBackGraphicColor("rgb(192, 192, 192)");
    }
    // Calcula a rotação
    setRotate(Math.min(100, data) * 3.6);
    setBackGraphicRotate(backGraphicData * 3.6);
  }, [data, backGraphicData]);

  useEffect(() => {
    // Define o tamanho da classe com base no tamanho
    if (size === "sm") {
      setClassName("circleSm");
    } else if (size === "md") {
      setClassName("circleMd");
    } else {
      setClassName("");
    }
  }, [size]);

  return (
    <div className="containerGraphicsRadius">
      <div className="graphicGroup">
        <div className={"graphicCircle circleOne " + className}>
          <div className="graphicLegend">
            {size !== "md" && size !== "sm" ? (
              <span className="textLegend">{legend}:</span>
            ) : null}
            <span className="valueLegendGraphic">
              {data}
              {signal}
            </span>
          </div>
        </div>
        <div
          className={"graphicCircle circleTwo " + className}
          style={{
            background: `conic-gradient(${color} ${rotate}deg, ${backGraphicColor} 0deg ${backGraphicRotate}deg, rgb(192, 192, 192) ${rotate}deg 360deg)`,
          }}
        ></div>
      </div>
      {size === "md" || size === "sm" ? (
        <span className={"textLegend " + className}>{legend}</span>
      ) : null}
    </div>
  );
};

export default GraphicsRadius;